__turbopack_context__.v({
  "description": "JooUea_description",
  "descriptionCollapseIcon": "JooUea_descriptionCollapseIcon",
  "descriptionExpandIcon": "JooUea_descriptionExpandIcon",
  "toggleDescriptionBtn": "JooUea_toggleDescriptionBtn",
});
